var $ = require('jquery');
var slick = require('slick-carousel');

require('fancybox')($);
require('./jquery.maskedinput');

module.exports = (function() {
	window.jQuery = $;

	$.extend(true,$.fancybox.defaults,{helpers:{overlay:{locked:false}},tpl:{closeBtn:'<a class="fancybox-item fancybox-close"></a>',next:'<a class="fancybox-nav fancybox-next"><span></span></a>',prev:'<a class="fancybox-nav fancybox-prev"><span></span></a>'}});

	//$(document).ready(function() {
		$('.fancybox').fancybox();

		$('[type="tel"]').mask('+7 (999) 999-99-99');
/*
		$('.slick').slick({
			prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-slider-prev"></i></button>',
			nextArrow: '<button type="button" class="slick-next"><i class="icon icon-slider-next"></i></button>'
		});
*/
		$('.toggle.navbar__item').on('click', function(e) {
			$('.topline__item--active').removeClass('topline__item--active');
			$('.wrapper').not(this.dataset.toggleTarget).removeClass('wrapper--open');
			$(this).toggleClass('navbar__item--active').siblings().removeClass('navbar__item--active');
		});

		$('.toggle.topline__item').on('click', function(e) {
			$('.navbar__item--active').removeClass('navbar__item--active');
			$('.wrapper').not(this.dataset.toggleTarget).removeClass('wrapper--open');
			$(this).toggleClass('topline__item--active').siblings().removeClass('topline__item--active');
		});

		$('.toggle').each(function() {
			var target = this.dataset.toggleTarget,
				evt = this.dataset.toggleEvent;

			if( ! evt) evt = 'click';

			$(this).on(evt, function(e) {
				$(target).toggleClass(this.dataset.toggleClass);

				if(this.tag == 'A' && evt == 'click') {
					e.preventDefault();
					e.stopPropagation();
				}
			});
		});

		$('.checkbox').prepend('<span class="checkbox__icon"><i class="icon icon-checked"></i></span>')
			.each(function() {
				var $this = $(this);

				$this.find(':checkbox').on('change', function() {
					$this.toggleClass('checkbox--checked');

					if( ! this.checked) {
						$(this).prop('checked', false).removeAttr('checked');
					}
				});
			})
			.filter(':has(:checked)').addClass('checkbox--checked');

		$('.checkbox--check-all :checkbox').on('click', function() {
			if($(this).is(':checked')) {
				$(this).closest('form').find(':checkbox[name="'+this.dataset.name+'"]').prop('checked', true).attr('checked', 'checked').parent().addClass('checkbox--checked');
			} else {
				$(this).closest('form').find(':checkbox[name="'+this.dataset.name+'"]').prop('checked', false).removeAttr('checked').parent().removeClass('checkbox--checked');
			}
		});

		$(':checkbox').on('change', function() {
			if($(this).closest('.checkbox--check-all').length > 0) return;

			$('.checkbox--check-all :checkbox[data-name="'+this.name+'"]').prop('checked', false).removeAttr('checked').parent().removeClass('checkbox--checked');
		});

		$('.select').not(':has(.icon-select)').append('<i class="icon icon-select"></i>');

		$(window).on('resize', function() {
			$('.format:visible').each(function() {
				var $format = $(this);

				$format.find('table').each(function() {
					var $this = $(this),
						$parent = $this.parent();

					if($parent.hasClass('overflow')) {
						if($format.innerWidth() >= $this.outerWidth()) {
							$this.unwrap();
						}
					} else if($format.innerWidth() < $this.outerWidth()) {
						$this.wrap('<div class="overflow"></div>');
					}
				});
			});
		}).trigger('resize');

		$('.table--dotted td').not(':has(.val)').wrapInner('<span class="val">');

		(function() {
			var $totop = $('<a href="#no-click" class="to-top hide"></a>');

			$totop.on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				$('html, body').animate({ scrollTop: 0 }, 'slow');
			});

			$('body').append($totop);

			$(window).on('scroll', function() {
				if($(this).scrollTop() > 350) {
					$totop.removeClass('hide');
				} else {
					$totop.addClass('hide');
				}
			});
		})();



		if(navigator.platform.indexOf('iPad') != -1) {
			document.querySelector('meta[name=viewport]').setAttribute('content', 'width=1200');
		}
	//});
})();
